// https://www.youtube.com/oembed?url=http%3A//youtube.com/watch%3Fv%3DNX9DTboxWVY&format=json

import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { LectureApiBase } from './lecture-api'

export interface NhkDetail {
  queryData: {
    uri: string
  }
  result: {
    id: string
    contentType: string
    name: string
    about: {
      nfsSeriesName: string
    }
    description: string
    text: null
    url: string
    thumbnailUrl: string
    grades: string[]
    subjectAreas: string[]
    curriculumStandard: {
      curriculumStandardVersion: string
      curriculumStandardNfsId: string
      curriculumStandardCode: string
    }[]
    keywords: string[]
    duration: string
    encodingFormat: string
    uploadDate: string
    dateModified: string
    datePublished: string
    expires: null
    regionsAllowed: null
    usageInfo: string
    bitrate: string
    height: number
    width: number
    hasPart: {
      clipNumber: number
      startOffset: number
      endOffset: number
      thumbnailUrl: string
      name: string
    }[]
  }[]
}

@Injectable()
export class NhkDetailApi {
  constructor(
    private api: LectureApiBase,
  ) { }

  fetch(dasId: string): Observable<NhkDetail> {
    return this.api.get(this.api.makeUrlWithParams('nhk_detail' , { dasId }))
  }
}



// WEBPACK FOOTER //
// ./src/apis/nhk-detail.ts